import { ModalWrapper } from "../../../components/ModalWrapper";
import { SignalReportSubmissionCard } from "../../../components";
import SignalCheckDataReview from "./SignalCheckDataReview";

export const SignalCheckReviewModal = ({ contentData, onClose, onActionSelect, onActionUndo }) => {
  const isOpen = !!contentData;

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <ModalWrapper
      title="SignalCheck hit(s) report"
      isOpen={isOpen}
      onClose={handleCloseModal}
    >
      <SignalReportSubmissionCard data={contentData} />
      <SignalCheckDataReview 
        data={contentData} 
        onActionSelect={onActionSelect}
        onActionUndo={onActionUndo}
      />
    </ModalWrapper>
  );
};
